<template>
	<v-container class="mt-4 px-5" fluid>
	  <v-row v-if="puedeVerInscripciones">
	  	<v-col cols="12">
	  		<v-card class="shadowCard">

	  			<!-- Titulo -->
	  		  <v-card-title primary-title>
	  		    <span v-if="!soloVeBotonGrupos" class="text-subtitle-1">Inscripciones alumnos</span>
	  		    <v-spacer></v-spacer>

            <v-tooltip
              v-if="puedeVerReferidos && !soloVeBotonGrupos"
              bottom
              color="blue"
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2 mb-2"
                  small dark color="purple"
                  @click="dialogReferidos = true"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-account-group</v-icon>
                </v-btn>
              </template>
              <span>Ver alumnos que han recomendado y si sus referidos pagaron</span>
            </v-tooltip>

            <!-- Agregar botón para ver alumnos que no tienen twilio asignado -->
            <v-tooltip v-if="!soloVeBotonGrupos" bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2 mb-2"
                  small dark color="red"
                  @click="dialogAlumnosSinTwilio = true"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-account-group</v-icon>
                </v-btn>
              </template>
              <span>Ver alumnos que no tienen twilio asignado</span>
            </v-tooltip>
           

            <v-tooltip
              v-if="puedeVerResumenPagado && !soloVeBotonGrupos"
              bottom
              color="blue"
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2 mb-2"
                  small dark color="blue darken-2"
                  @click="abrirResumenPagado()"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-cash-multiple</v-icon>
                </v-btn>
              </template>
              <span>Ver resumen de monto pagado por plantel</span>
            </v-tooltip>

            <v-tooltip v-if="!soloVeBotonGrupos" bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2 mb-2"
                  small dark color="green"
                  @click="exportarInscripciones()"
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
              </template>
              <span>Descargar las inscripciones en formato Excel</span>
            </v-tooltip>

            <v-tooltip v-if="puedeVerBotonGrupos" bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="grey"
                  dark
                  class="mb-2 mr-2 text-capitalize"
                  @click="dialogGrupos.estatus = true "
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-google-classroom</v-icon>
                  Grupos
                </v-btn>
              </template>
              <span>Ver todos los grupos disponibles con sus horarios y espacios</span>
            </v-tooltip>

            <v-tooltip v-if="!soloVeBotonGrupos" bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="orange"
                  dark
                  class="mb-2 mr-2 text-capitalize"
                  @click="abrirModalRegistro()"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-cash</v-icon>
                  Realizar pago
                </v-btn>
              </template>
              <span>Procesar pagos de alumnos RI y NI</span>
            </v-tooltip>

            <v-tooltip
              v-if="puedeVerPagosEliminados && !soloVeBotonGrupos"
              bottom
              color="blue"
              max-width="300"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red darken-2"
                  dark
                  class="mb-2 mr-2 text-capitalize"
                  @click="abrirPagosEliminados()"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left small>mdi-cash-remove</v-icon>
                  Pagos eliminados
                </v-btn>
              </template>
              <span>Buscar pagos eliminados por matrícula del alumno</span>
            </v-tooltip>

            <v-tooltip v-if="!soloVeBotonGrupos" bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 text-capitalize"
                  @click="initialize()"
                  small
                  tile
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </template>
              <span>Actualizar búsqueda según plantel o ciclo seleccionado</span>
            </v-tooltip>
	  		  </v-card-title>

	  		  <v-card-text v-if="!soloVeBotonGrupos">

	  		  	<!-- Filtros -->
	  		  	<v-row justify="end">
	  		  		<!-- Seleccionar el plantel -->
	  		  		<v-col cols="12" sm="6" md="4" lg="3">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-autocomplete
                      label="Plantel"
                      id="id"
                      filled
                      dense
                      single-line
                      hide-details
                      v-model="plantel"
                      :items="planteles"
                      item-text="plantel"
                      item-value="id_plantel"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-autocomplete>
                  </template>
                  <span>Filtra los alumnos por plantel</span>
                </v-tooltip>
	  		  		</v-col>

	  		  		<!-- Seleccionar el ciclo -->
	  		  		<v-col cols="12" sm="6" md="4" lg="3">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-autocomplete
                      label="Ciclo"
                      id="id"
                      filled
                      dense
                      single-line
                      hide-details
                      v-model="ciclo"
                      :items="ciclos"
                      item-text="ciclo"
                      item-value="id_ciclo"
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-autocomplete>
                  </template>
                  <span>Filtra los alumnos por ciclo escolar</span>
                </v-tooltip>
	  		  		</v-col>
	  		  		<v-spacer></v-spacer>
	  		  		<v-col cols="12" sm="6" md="4" lg="3">
                <v-tooltip bottom color="blue" max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      name="name"
                      label="Buscar"
                      id="id"
                      filled
                      dense
                      hide-details
                      single-line
                      append-icon="mdi-magnify"
                      v-model="search"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <span>Buscar por horario, nombre, matrícula, teléfono, monto o folio</span>
                </v-tooltip>
	  		  		</v-col>
	  		  	</v-row>

	  		  	<v-row>
	  		  		<v-col cols="12" class="pt-0">
		  		  		<v-radio-group
					      v-model="tipoFiltro"
					      row
					      hide-details
					    >
                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="Todos"
                        :value="3"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Muestra todos los alumnos del plantel y ciclo seleccionado</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="Sin aduedo"
                        :value="1"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos que han pagado completamente su nivel</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="Con aduedo"
                        :value="2"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos con pagos parciales pendientes</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="RI"
                        :value="4"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos que han pagado su siguiente nivel (Reinscripción)</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="NO RI"
                        :value="5"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos que no han pagado el próximo ciclo</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="NI"
                        :value="6"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos de nuevo ingreso en el ciclo</span>
                  </v-tooltip>

                  <v-tooltip bottom color="blue" max-width="300">
                    <template v-slot:activator="{ on, attrs }">
                      <v-radio
                        label="Con calavera"
                        :value="7"
                        v-bind="attrs"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <span>Alumnos en grupos marcados para reubicar (calavera)</span>
                  </v-tooltip>
					    </v-radio-group>
		  		  	</v-col>
					</v-row>

	  		  	<!-- Tabla -->
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="filterAlumnos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
			            id="grupos"
			            item-class="clase_row"
			            :page.sync="page"
			            :items-per-page.sync="itemsPerPage"
			            :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
							  >
							    <template v-slot:item.actions="{ item }">
							    	<v-btn
							    		color="primary"
							    		x-small
							    		@click="editItem(item)"
							    		class="mr-2"
							    		tile
							    	>
								      <v-icon small>mdi-magnify</v-icon>
							    	</v-btn>
							    </template>

							    <template v-slot:item.conTutor="{ item }">
							    	<v-chip
							    		@click="verTutor( item ) "
							    		:color="item.conTutor ? 'green' : 'red'" dark small label>{{ item.conTutor ? 'SI' : 'NO' }} </v-chip>
							    </template>

							    <template v-slot:item.reubicacion="{ item }">
							    	<div class="d-flex justify-center align-center py-1">
							    		<v-tooltip v-if="alumnoConCalavera(item)" bottom color="blue" max-width="280">
							    			<template v-slot:activator="{ on, attrs }">
							    				<v-icon
							    					v-bind="attrs"
							    					v-on="on"
							    					color="grey darken-2"
							    					small
							    				>mdi-skull</v-icon>
							    			</template>
							    			<span>Alumno por reubicar (grupo con calavera)</span>
							    		</v-tooltip>
							    		<span v-else class="grey--text text--lighten-1">—</span>
							    	</div>
							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>
	  <v-row v-else>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  			<v-card-text class="text-center py-8">
	  				No tienes permiso para ver inscripciones.
	  			</v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

	  <!-- Dialogo de editar o agregar-->
	  <v-dialog
      v-model="dialog"
      max-width="1200px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1"><b>Alumno: {{ editedItem.alumno }} </b></span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.id_alumno }}</strong>
          </span>
        </v-card-title>
        <v-tabs vertical v-model="tabs">
        	<v-tab class="text-capitalize" v-for="(tab, i) in menu" :key="i">
		        <v-icon left v-text="tab.icono"></v-icon>
		        {{ tab.text }}
					</v-tab>

		      <!-- información del grupo -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text class="pt-0">
		          	<InfoAlumno  v-if="tabs == 0 && dialog" :editedItem="editedItem" @click="initialize()"/>
			        </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <!-- Tutro -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <Tutor v-if="tabs == 1 && dialog" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <!-- Grupos -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <GruposAlumno  v-if="tabs == 2 && dialog" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

		      <!-- Becas -->
		      <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <BecaAlumno  v-if="tabs == 3 && dialog" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

			 		<!-- Precios -->
			  <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <Precios  v-if="tabs == 4 && dialog" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>

			  <!-- Hermanos -->
			  <v-tab-item>
		        <v-card flat>
		          <v-card-text>
		            <Hermanos  v-if="tabs == 5 && dialog" :editedItem="editedItem"/>
		          </v-card-text>
		        </v-card>
		      </v-tab-item>
		    </v-tabs>


        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="close"
            small
          >
          	<v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogReferidos
      v-if="puedeVerReferidos"
      v-model="dialogReferidos"
      @error="validarError"
    />

    <!-- Pagos eliminados por matrícula -->
    <v-dialog
      v-model="dialogPagosEliminados"
      max-width="1280px"
      persistent
      scrollable
    >
      <v-card class="shadowCard">
        <v-card-title class="text-subtitle-1">
          Pagos eliminados
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="cerrarPagosEliminados()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="matriculaPagosEliminados"
                label="Matrícula"
                placeholder="2026-44347 o 44347"
                filled
                dense
                hide-details
                clearable
                @keyup.enter="buscarPagosEliminados()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                color="primary"
                dark
                small
                tile
                class="text-capitalize"
                :loading="cargandoPagosEliminados"
                @click="buscarPagosEliminados()"
              >
                <v-icon left small>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <v-alert
            v-if="mensajePagosEliminados"
            dense
            text
            :type="tipoMensajePagosEliminados"
            class="mt-4 mb-0"
          >
            {{ mensajePagosEliminados }}
          </v-alert>

          <div
            v-if="alumnoPagosEliminados"
            class="mt-4 mb-2"
          >
            <strong>Alumno:</strong> {{ alumnoPagosEliminados.alumno }}
            · <strong>Matrícula:</strong> {{ alumnoPagosEliminados.matricula }}
            · <strong>ID:</strong> {{ alumnoPagosEliminados.id_alumno }}
            <span v-if="alumnoPagosEliminados.folio_prospecto">
              · <strong>Folio prospecto:</strong> {{ alumnoPagosEliminados.folio_prospecto }}
            </span>
          </div>

          <v-data-table
            v-if="alumnoPagosEliminados"
            :headers="headersPagosEliminados"
            :items="listaPagosEliminados"
            class="elevation-0 mt-2"
            dense
            :loading="cargandoPagosEliminados"
            item-key="id_ingreso"
          >
            <template v-slot:item.forma_pago="{ item }">
              {{ item.forma_pago || '—' }}
            </template>
            <template v-slot:item.nombre_capturo="{ item }">
              {{ item.nombre_capturo || '—' }}
            </template>
            <template v-slot:item.nombre_elimino="{ item }">
              {{ item.nombre_elimino || item.nombre_completo || '—' }}
            </template>
            <template v-slot:item.motivo_eliminacion="{ item }">
              <span class="text-caption">{{ item.motivo_eliminacion || '—' }}</span>
            </template>
            <template v-slot:item.folio_prospecto="{ item }">
              {{ item.folio_prospecto || alumnoPagosEliminados.folio_prospecto || '—' }}
            </template>
            <template v-slot:item.url_foto="{ item }">
              <div v-if="item.url_foto" class="d-flex align-center" style="gap: 4px;">
                <v-btn
                  icon
                  x-small
                  color="primary"
                  title="Ver comprobante"
                  @click="abrirImagenPagoEliminado(item)"
                >
                  <v-icon x-small>mdi-eye</v-icon>
                </v-btn>
                <v-btn
                  icon
                  x-small
                  color="teal"
                  title="Descargar comprobante"
                  tag="a"
                  :href="urlComprobantePagoEliminado(item)"
                  :download="item.url_foto"
                  target="_blank"
                  rel="noopener"
                >
                  <v-icon x-small>mdi-download</v-icon>
                </v-btn>
              </div>
              <span v-else class="grey--text text-caption">Sin imagen</span>
            </template>
            <template v-slot:no-data>
              <span class="grey--text">Sin pagos eliminados</span>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            dark
            small
            tile
            class="text-capitalize"
            @click="cerrarPagosEliminados()"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogImagenPagoEliminado"
      max-width="900px"
    >
      <v-card class="shadowCard">
        <v-card-title class="text-subtitle-1">
          Comprobante de pago
          <v-spacer></v-spacer>
          <v-btn
            v-if="imagenPagoEliminadoUrl"
            small
            tile
            tag="a"
            color="teal"
            dark
            class="mr-2 text-capitalize"
            :href="imagenPagoEliminadoUrl"
            :download="imagenPagoEliminadoNombre || 'comprobante'"
            target="_blank"
            rel="noopener"
          >
            <v-icon left small>mdi-download</v-icon>
            Descargar
          </v-btn>
          <v-btn icon small @click="cerrarImagenPagoEliminado()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          <img
            v-if="imagenPagoEliminadoUrl"
            :src="imagenPagoEliminadoUrl"
            :alt="imagenPagoEliminadoNombre || 'Comprobante'"
            style="max-width: 100%; max-height: 70vh; object-fit: contain;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAlumnosSinTwilio" max-width="1200px">
      <v-card>
        <v-card-title>Alumnos que no tienen twilio asignado</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnosSinTwilio"
            :items="alumnosSinTwilio"
          >
            <!-- Agragar botón para subir imagen a cada alumnos -->
            <template v-slot:item.imagen_twilio="{ item }">
              <v-btn
                v-if="!item.imagen_twilio"
                color="primary"
                x-small
                @click="subirImagen(item)"
              >
                <v-icon small>mdi-image</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="dialogAlumnosSinTwilio = false"
            small
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogResumenPagado" max-width="900px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Resumen de monto pagado por plantel
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersResumenPagado"
            :items="resumenPagadoPorPlantel"
            class="elevation-0"
            dense
            hide-default-footer
            :items-per-page="-1"
            :loading="cargandoCifrasCorte"
          >
            <template v-slot:item.total="{ item }">
              {{ formatMoneda(item.total) }}
            </template>
            <template v-slot:item.corte="{ item }">
              {{ formatMoneda(item.corte) }}
            </template>
            <template v-slot:item.diferencia="{ item }">
              <span :class="item.diferencia !== 0 ? 'red--text font-weight-bold' : ''">
                {{ formatMoneda(item.diferencia) }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                x-small
                tile
                @click="verDiferenciaPlantel(item)"
                :disabled="!ciclo"
              >
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-divider class="my-3"></v-divider>

          <div class="d-flex justify-space-between align-center px-2 mb-1">
            <span class="text-subtitle-1 font-weight-bold">Total monto pagado</span>
            <span class="text-subtitle-1 font-weight-bold">{{ formatMoneda(totalPagadoPlantel) }}</span>
          </div>
          <div class="d-flex justify-space-between align-center px-2 mb-1">
            <span class="text-subtitle-1 font-weight-bold">Total corte</span>
            <span class="text-subtitle-1 font-weight-bold">{{ formatMoneda(totalCortePlantel) }}</span>
          </div>
          <div class="d-flex justify-space-between align-center px-2">
            <span class="text-subtitle-1 font-weight-bold">Total diferencia</span>
            <span class="text-subtitle-1 font-weight-bold" :class="totalDiferenciaPlantel !== 0 ? 'red--text' : ''">
              {{ formatMoneda(totalDiferenciaPlantel) }}
            </span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="dialogResumenPagado = false"
            small
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDiferenciaPlantel" max-width="1100px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Diferencia — {{ plantelDiferencia ? plantelDiferencia.plantel : '' }}
        </v-card-title>
        <v-card-text>
          <v-row class="mb-2">
            <v-col cols="12" sm="4">
              <div class="text-caption grey--text">Monto pagado (inscripciones)</div>
              <div class="text-subtitle-1 font-weight-bold">{{ formatMoneda(plantelDiferencia ? plantelDiferencia.total : 0) }}</div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="text-caption grey--text">Corte (cifra final)</div>
              <div class="text-subtitle-1 font-weight-bold">{{ formatMoneda(plantelDiferencia ? plantelDiferencia.corte : 0) }}</div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="text-caption grey--text">Diferencia</div>
              <div class="text-subtitle-1 font-weight-bold" :class="plantelDiferencia && plantelDiferencia.diferencia !== 0 ? 'red--text' : ''">
                {{ formatMoneda(plantelDiferencia ? plantelDiferencia.diferencia : 0) }}
              </div>
            </v-col>
          </v-row>

          <v-alert v-if="!cargandoDiferenciaPlantel && detalleDiferenciaPlantel.length === 0" type="success" dense text class="mb-3">
            No hay diferencias por alumno entre inscripciones y corte.
          </v-alert>

          <v-alert v-else-if="detalleDiferenciaPlantel.length" type="info" dense text class="mb-3">
            Registros que explican la diferencia entre el monto pagado en inscripciones y el corte (ingresos).
          </v-alert>

          <v-data-table
            :headers="headersDiferenciaPlantel"
            :items="detalleDiferenciaPlantel"
            class="elevation-0"
            dense
            :loading="cargandoDiferenciaPlantel"
            :items-per-page="10"
          >
            <template v-slot:item.monto_inscripcion="{ item }">
              {{ formatMoneda(item.monto_inscripcion) }}
            </template>
            <template v-slot:item.monto_corte="{ item }">
              {{ formatMoneda(item.monto_corte) }}
            </template>
            <template v-slot:item.diferencia="{ item }">
              <span :class="item.diferencia !== 0 ? 'red--text font-weight-bold' : ''">
                {{ formatMoneda(item.diferencia) }}
              </span>
            </template>
            <template v-slot:item.tipo="{ item }">
              <v-chip
                small
                dark
                :color="colorTipoDiferencia(item.tipo)"
              >
                {{ item.tipo }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="dialogDiferenciaPlantel = false"
            small
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogSubirImagen" max-width="400px" @keydown.ctrl="pegar">
      <v-card 
        v-if="alumnoSeleccionado"
        max-width="600px" 
      >
        <v-card-title class="text-subtitle-1">
          Subir imagen
        </v-card-title>
        <v-card-text>
          <v-tooltip bottom color="blue" max-width="300" v-if="!file">
            <template v-slot:activator="{ on, attrs }">
              <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false" v-bind="attrs" v-on="on">
                <div class="dropZone-info" @drag="onChange">
                  <span class="fa fa-cloud-upload dropZone-title"></span>
                  <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                  <div class="dropZone-upload-limit-info">
                    <div>Extensión: png, jpg, jpeg, svg</div>
                    <div>Tamaño máximo: 10 MB</div>
                  </div>
                </div>
                <input type="file" @change="onChange">
              </div>
            </template>
            <span>Sube el comprobante de pago (captura de transferencia)</span>
          </v-tooltip>

          <div v-else>
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="red" class="mb-2" dense @click="removeFile" fab small dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar el comprobante cargado</span>
            </v-tooltip>
            <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300" max-width="300"/>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            @click="dialogSubirImagen = false"
          >
            <v-icon left small>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para ver todos los grupos habiles que hay -->
    <GruposHabiles v-if="dialogGrupos.estatus == true"    :dialogGrupos="dialogGrupos"/>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"          :parametros="parametros"/>
    <carga                v-if="cargar"/>
    <DialogInscripcion    v-if="inscribir.estatus == true"          :inscribir="inscribir"/>

    <dialogSteppers
    	v-if="dialogAddAlumno.estatus"
    	:dialogAddAlumno="dialogAddAlumno"
    />

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta             from '@/components/alertas/Alerta.vue'
  import carga              from '@/components/alertas/carga.vue';
  import InfoAlumno         from '@/components/inscripciones/InfoAlumno.vue';
  import GruposAlumno       from '@/components/inscripciones/GruposAlumno.vue';
  import Tutor              from '@/components/inscripciones/Tutor.vue';
  import BecaAlumno         from '@/components/inscripciones/BecaAlumno.vue';
  import DialogInscripcion  from '@/components/inscripciones/DialogInscripcion.vue';
  import Precios            from '@/components/inscripciones/Precios.vue';
  import Hermanos           from '@/components/inscripciones/Hermanos.vue';
  import dialogSteppers     from '@/components/inscripciones/steppers/dialogSteppers.vue'
  import DialogReferidos    from '@/components/inscripciones/DialogReferidos.vue'

  import GruposHabiles      from '@/components/grupos/GruposHabiles.vue';

  import validarErrores  from '@/mixins/validarErrores'
  import funcionesExcel  from '@/mixins/funcionesExcel'
  import { Clipboard }   from "@capacitor/clipboard";

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
      InfoAlumno,
      GruposAlumno,
      Tutor,
      BecaAlumno,
      DialogInscripcion,
      GruposHabiles,
		  Precios,
		  Hermanos,
		  dialogSteppers,
      DialogReferidos
    },

    data: () => ({
    	tabs: 0,
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      editedIndex: -1,

      editedItem: {
        id_grupo:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      defaultItem: {
        id_grupo:0,
				forma_pago:'',
				comentarios:'',
				fecha_alta:null,
				activo_sn:0,
				fecha_baja:null,
				id_usuario_ultimo_cambio:0,
				fecha_ultimo_cambio:null,
      },

      // Filtros:
      incio:null,
			fin:null,
			plantel: null,
			ciclo: null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      grupos: [],
      alumnos:[],
      headers: [
        { text: 'ID'                      , value: 'id_alumno'            },
				{ text: 'Folio Prospecto'         , value: 'folioProspecto'		  },
        { text: 'Matricula'               , value: 'matricula'            },
        // { text: 'Matricula ERP'           , value: 'matricula_erp'        },
        { text: 'Alumno'                  , value: 'alumno'               },
        { text: 'Celular'                 , value: 'celular'              },
        { text: 'Grupo'                   , value: 'grupo'                },
        { text: 'Precio grupo'            , value: 'precio'               },
        { text: 'Precio con descuento'    , value: 'precio_grupo_con_descuento_x_alumno' },
        { text: 'Monto pagado'            , value: 'pagado'               },
        { text: 'Monto adeudo'            , value: 'adeudo'               },
        { text: 'Diferencia'              , value: 'diferencia'           },
        { text: 'Reubicación'             , value: 'reubicacion', align: 'center' },
        { text: 'Alta'                    , value: 'fecha_inscripcion'    },
        { text: 'Edad'                    , value: 'edad',  align: 'center'},
        { text: 'Tutor'                   , value: 'conTutor'             },
        { text: 'Actions'                 , value: 'actions'              },
      ],

      ciclos:[],
			planteles:[],
			inscribirAlumno: false,
			inscribir: { estatus: false },
			menu:[{text:'Alumno',icono:'mdi-account'},{text:'Tutor',icono:'mdi-account'},{text:'Pagos',icono:'mdi-bitcoin'},{text:'Beca',icono:'mdi-percent-outline'},{text:'Precios',icono:'mdi-currency-usd'}, {text:'Hermanos',icono:'mdi-account-multiple '}],
			tipoFiltro: 3,

			dialogGrupos: {
				estatus: false
			},
			dialogAddAlumno:{
      	estatus: false
      },

      dialogAlumnosSinTwilio: false,
      dialogReferidos: false,
      dialogResumenPagado: false,
      dialogDiferenciaPlantel: false,
      dialogPagosEliminados: false,
      matriculaPagosEliminados: '',
      alumnoPagosEliminados: null,
      listaPagosEliminados: [],
      mensajePagosEliminados: '',
      tipoMensajePagosEliminados: 'info',
      cargandoPagosEliminados: false,
      dialogImagenPagoEliminado: false,
      imagenPagoEliminadoUrl: '',
      imagenPagoEliminadoNombre: '',
      headersPagosEliminados: [
        { text: 'Folio prospecto', value: 'folio_prospecto', width: 120 },
        { text: 'Curso', value: 'curso' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Tipo de pago', value: 'forma_pago', width: 120 },
        { text: 'Pagado', value: 'pagado', width: 90 },
        { text: 'Fecha pago', value: 'fecha_alta', width: 110 },
        { text: 'Quién capturó', value: 'nombre_capturo' },
        { text: 'Quién eliminó', value: 'nombre_elimino' },
        { text: 'Motivo eliminación', value: 'motivo_eliminacion' },
        { text: 'Imagen', value: 'url_foto', sortable: false, width: 100, align: 'center' },
      ],
      cargandoCifrasCorte: false,
      cargandoDiferenciaPlantel: false,
      fechaCorteResumen: null,
      cifrasCorte: [],
      plantelDiferencia: null,
      detalleDiferenciaPlantel: [],
      headersResumenPagado: [
        { text: 'Plantel'      , value: 'plantel'     },
        { text: 'Monto pagado' , value: 'total'       , align: 'right' },
        { text: 'Corte'        , value: 'corte'       , align: 'right' },
        { text: 'Diferencia'   , value: 'diferencia'  , align: 'right' },
        { text: ''             , value: 'actions'     , sortable: false, align: 'center' },
      ],
      headersDiferenciaPlantel: [
        { text: 'Matricula'           , value: 'matricula'          },
        { text: 'Alumno'              , value: 'alumno'             },
        { text: 'Grupo'               , value: 'grupo'              },
        { text: 'Monto inscripción'   , value: 'monto_inscripcion'  , align: 'right' },
        { text: 'Monto corte'         , value: 'monto_corte'        , align: 'right' },
        { text: 'Diferencia'          , value: 'diferencia'         , align: 'right' },
        { text: 'Causa'               , value: 'tipo'               },
      ],
      headersAlumnosSinTwilio: [
        { text: 'Matricula'    , value: 'matricula'     },
        { text: 'Alumno'       , value: 'alumno'        },
        { text: 'Grupo'        , value: 'grupo'         },
        { text: 'Imagen'       , value: 'imagen_twilio' },
        { text: 'Texto Imagem' , value: 'twilio_texto'  },
      ],

      alumnoSeleccionado: null,
      dialogSubirImagen: false,

      file: '',
      dragging: false,
      vistaPrevia: null,
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Grupo' : 'Editar Grupo'
      },

      alumnosSinTwilio( ){
        return this.alumnos.filter( el => { return !el.twilio_asignado })
      },

      puedeVerResumenPagado () {
        return this.getdatosUsuarioERPERP && [28, 334].includes(this.getdatosUsuarioERPERP.iderp)
      },

      puedeVerReferidos () {
        return this.getdatosUsuarioERPERP && [32, 28, 31, 568, 334].includes(Number(this.getdatosUsuarioERPERP.iderp))
      },

      /** Misma regla que valida el API en inscripciones.ingresos.eliminados.buscar */
      puedeVerPagosEliminados () {
        const u = this.getdatosUsuarioERPERP
        if (!u) return false
        const iderp = Number(u.iderp)
        const idpuesto = Number(u.idpuesto)
        return [28, 334].includes(iderp) || [11, 12].includes(idpuesto)
      },

      esCoordinadorAcademico () {
        const u = this.getdatosUsuarioERPERP
        if (!u || !u.puesto) return false
        const puesto = String(u.puesto).toLowerCase()
        return puesto.indexOf('coord') !== -1 && puesto.indexOf('acad') !== -1
      },

      esCarlosEduardoDeLeon () {
        const u = this.getdatosUsuarioERPERP
        return !!(u && Number(u.iderp) === 1177)
      },

      soloVeBotonGrupos () {
        return this.esCarlosEduardoDeLeon
      },

      puedeVerInscripciones () {
        if (this.esCarlosEduardoDeLeon) return true
        if (this.esCoordinadorAcademico) return false
        return true
      },

      puedeVerBotonGrupos () {
        if (this.esCoordinadorAcademico) return this.esCarlosEduardoDeLeon
        return true
      },

      resumenPagadoPorPlantel () {
        const mapa = {}

        this.filterAlumnos.forEach((alumno) => {
          const idPlantel = alumno.id_plantel
          if (!mapa[idPlantel]) {
            mapa[idPlantel] = {
              id_plantel: idPlantel,
              plantel: alumno.plantel || 'Sin plantel',
              total: 0,
            }
          }
          mapa[idPlantel].total += parseFloat(alumno.pagado) || 0
        })

        return Object.values(mapa).map((row) => {
          const cifra = this.cifrasCorte.find((c) => c.id_plantel == row.id_plantel)
          const corte = cifra ? parseFloat(cifra.cifra_final) || 0 : 0
          return {
            ...row,
            corte,
            diferencia: row.total - corte,
          }
        }).sort((a, b) => a.plantel.localeCompare(b.plantel))
      },

      totalPagadoPlantel () {
        return this.resumenPagadoPorPlantel.reduce((acc, row) => acc + row.total, 0)
      },

      totalCortePlantel () {
        return this.resumenPagadoPorPlantel.reduce((acc, row) => acc + row.corte, 0)
      },

      totalDiferenciaPlantel () {
        return this.totalPagadoPlantel - this.totalCortePlantel
      },

      filterAlumnos( ){
      	let alumnos = this.alumnos

      	if( this.tipoFiltro == 1 ){
      		alumnos = alumnos.filter( el => { return el.adeudo <= 0 })
      	}

      	if( this.tipoFiltro == 2 ){
      		alumnos = alumnos.filter( el => { return el.adeudo > 0 })
      	}

      	if( this.tipoFiltro == 4 ){
      		alumnos = alumnos.filter( el => { return el.clase_row == 'alumno_ri' })
      	}

      	if( this.tipoFiltro == 5 ){
      		alumnos = alumnos.filter( el => { return el.clase_row != 'alumno_ri'})
      	}

      	if( this.tipoFiltro == 6 ){
      		alumnos = alumnos.filter( el => { return el.alumno_ni == 1 })
      	}

      	if( this.tipoFiltro == 7 ){
      		alumnos = alumnos.filter( el => this.alumnoConCalavera(el) )
      	}

      	if( this.plantel && !this.ciclo ){
      		return alumnos.filter( el=> { return el.id_plantel == this.plantel })
      	}

      	if( this.plantel && this.ciclo){
      		return alumnos.filter( el=> { return el.id_plantel == this.plantel && el.id_ciclo == this.ciclo })
      	}

      	if( !this.plantel && this.ciclo){
      		return alumnos.filter( el=> { return el.id_ciclo == this.ciclo })
      	}

      	if( !this.plantel && !this.ciclo){
      		return alumnos
      	}
      }
    },

    watch: {
      dialog (val) { val || this.close() },

      tabs( val ) { console.log( val ) },

      ciclo( val ) { if( val && !this.soloVeBotonGrupos ){ this.initialize() } }

    },

    async created () {
      if (this.soloVeBotonGrupos) return
      await this.getCiclos()
      await this.getPlanteles()
    },

    methods: {
      formatMoneda (valor) {
        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(valor || 0)
      },

      abrirResumenPagado () {
        if (!this.ciclo) {
          this.validarError('Selecciona un ciclo para ver el resumen')
          return
        }
        this.dialogResumenPagado = true
        this.cargarCifrasCorte()
      },

      abrirPagosEliminados () {
        this.dialogPagosEliminados = true
        this.matriculaPagosEliminados = ''
        this.alumnoPagosEliminados = null
        this.listaPagosEliminados = []
        this.mensajePagosEliminados = ''
        this.tipoMensajePagosEliminados = 'info'
        this.cerrarImagenPagoEliminado()
      },

      cerrarPagosEliminados () {
        this.dialogPagosEliminados = false
        this.matriculaPagosEliminados = ''
        this.alumnoPagosEliminados = null
        this.listaPagosEliminados = []
        this.mensajePagosEliminados = ''
        this.cargandoPagosEliminados = false
        this.cerrarImagenPagoEliminado()
      },

      urlComprobantePagoEliminado (item) {
        if (!item || !item.url_foto) return ''
        const nombre = item.url_foto
        const base = String((this.$http && this.$http.defaults && this.$http.defaults.baseURL) || (axios.defaults && axios.defaults.baseURL) || '')
        if (base && base !== '/') {
          return base.replace(/\/?$/, '/') + 'comprobante-pago/' + nombre
        }
        return 'comprobante-pago/' + nombre
      },

      abrirImagenPagoEliminado (item) {
        if (!item || !item.url_foto) return
        this.imagenPagoEliminadoUrl = this.urlComprobantePagoEliminado(item)
        this.imagenPagoEliminadoNombre = item.url_foto
        this.dialogImagenPagoEliminado = true
      },

      cerrarImagenPagoEliminado () {
        this.dialogImagenPagoEliminado = false
        this.imagenPagoEliminadoUrl = ''
        this.imagenPagoEliminadoNombre = ''
      },

      buscarPagosEliminados () {
        const matricula = (this.matriculaPagosEliminados || '').trim()
        if (!matricula) {
          this.validarError('Ingresa una matrícula')
          return
        }

        this.cargandoPagosEliminados = true
        this.alumnoPagosEliminados = null
        this.listaPagosEliminados = []
        this.mensajePagosEliminados = ''

        return this.$http.post('inscripciones.ingresos.eliminados.buscar', { matricula: matricula }).then((response) => {
          this.alumnoPagosEliminados = response.data.alumno
          this.listaPagosEliminados = response.data.pagos || []
          if (!this.listaPagosEliminados.length) {
            this.tipoMensajePagosEliminados = 'warning'
            this.mensajePagosEliminados = 'Sin pagos eliminados'
          } else {
            this.tipoMensajePagosEliminados = 'success'
            this.mensajePagosEliminados = 'Se encontraron ' + this.listaPagosEliminados.length + ' pago(s) eliminado(s)'
          }
        }).catch((error) => {
          let msg = 'Error al buscar pagos eliminados'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.tipoMensajePagosEliminados = 'error'
          this.mensajePagosEliminados = msg
          this.validarError(msg)
        }).finally(() => {
          this.cargandoPagosEliminados = false
        })
      },

      cargarCifrasCorte () {
        this.fechaCorteResumen = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        this.cargandoCifrasCorte = true
        this.cifrasCorte = []

        return this.$http.post('corte.sucursal', {
          fecha_corte: this.fechaCorteResumen,
          id_plantel: null,
        }).then((response) => {
          this.cifrasCorte = (response.data.cifras || []).filter((cifra) => cifra.id_ciclo == this.ciclo)
        }).catch((error) => {
          this.validarError(error.response ? error.response.data.message : error.message)
        }).finally(() => {
          this.cargandoCifrasCorte = false
        })
      },

      colorTipoDiferencia (tipo) {
        if (tipo === 'Pago en corte sin inscripción') return 'red'
        if (tipo === 'Inscripción sin pago en corte') return 'blue'
        return 'orange'
      },

      verDiferenciaPlantel (item) {
        if (!this.ciclo || !item.id_plantel || !this.fechaCorteResumen) return

        this.plantelDiferencia = item
        this.dialogDiferenciaPlantel = true
        this.cargandoDiferenciaPlantel = true
        this.detalleDiferenciaPlantel = []

        this.$http.post('inscripciones.diferencia.plantel', {
          id_plantel: item.id_plantel,
          id_ciclo: this.ciclo,
          fecha_corte: this.fechaCorteResumen,
        }).then((response) => {
          this.detalleDiferenciaPlantel = response.data.detalle || []
        }).catch((error) => {
          this.validarError(error.response ? error.response.data.message : error.message)
        }).finally(() => {
          this.cargandoDiferenciaPlantel = false
        })
      },

      obtenerCicloPorFecha (ciclos, fecha = new Date()) {
        if (!ciclos || !ciclos.length) return null

        const hoy = new Date(fecha)
        hoy.setHours(0, 0, 0, 0)

        const enRango = ciclos.filter(c => {
          if (!c.fecha_inicio_ciclo || !c.fecha_fin_ciclo) return false
          const inicio = new Date(c.fecha_inicio_ciclo)
          const fin = new Date(c.fecha_fin_ciclo)
          inicio.setHours(0, 0, 0, 0)
          fin.setHours(0, 0, 0, 0)
          return hoy >= inicio && hoy <= fin
        })

        const ordenarPorVigencia = (lista) => lista.sort((a, b) => {
          const aCiclo = (a.ciclo || '').includes('CICLO') ? 1 : 0
          const bCiclo = (b.ciclo || '').includes('CICLO') ? 1 : 0
          if (bCiclo !== aCiclo) return bCiclo - aCiclo

          const aFe = (a.ciclo || '').includes(' FE') ? 1 : 0
          const bFe = (b.ciclo || '').includes(' FE') ? 1 : 0
          if (aFe !== bFe) return aFe - bFe

          return new Date(b.fecha_inicio_ciclo) - new Date(a.fecha_inicio_ciclo)
        })

        if (enRango.length) {
          return ordenarPorVigencia(enRango)[0]
        }

        const futuros = ciclos
          .filter(c => c.fecha_inicio_ciclo && new Date(c.fecha_inicio_ciclo) >= hoy)
          .sort((a, b) => new Date(a.fecha_inicio_ciclo) - new Date(b.fecha_inicio_ciclo))

        if (futuros.length) return futuros[0]

        const pasados = ciclos
          .filter(c => c.fecha_fin_ciclo)
          .sort((a, b) => new Date(b.fecha_fin_ciclo) - new Date(a.fecha_fin_ciclo))

        return pasados[0] || ciclos[0]
      },

      initialize () {
        if (!this.ciclo) {
          this.alumnos = []
          return Promise.resolve()
        }

      	this.cargar = true
        this.alumnos = []

        return this.$http.get('inscripciones.list/' + this.ciclo).then(response=>{
        	const rows = response.data || []
        	this.alumnos = rows.map(el => ({
        		...el,
        		reubicacion: this.alumnoConCalavera(el) ? 1 : 0
        	}))
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      alumnoConCalavera (item) {
      	if (!item) return false
      	const flag = item.reubicacion != null ? item.reubicacion : item.cerrado
      	return Number(flag) === 1 || flag === true || flag === '1'
      },

      getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data
          if (!this.ciclo) {
            const cicloActual = this.obtenerCicloPorFecha(this.ciclos)
            if (cicloActual) {
              this.ciclo = cicloActual.id_ciclo
            }
          }
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      verTutor( item ){
      	this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.tabs = 1
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

    	abrirModalRegistro ( ) {
    		// this.inscribirAlumno   = true
    		// this.inscribir.estatus = true
    		this.dialogAddAlumno.estatus = true
    	},

    	exportarInscripciones( ){

    		if( this.getdatosUsuarioERPERP.iderp == 32 ){
	    		const alumnos = this.filterAlumnos.map(({ id_alumno, matricula, folioProspecto, fechaProspecto, puesto, alumno, fecha_inscripcion, alumno_ni, id_grupo, grupo, precio, pagado, adeudo, diferencia, precio_con_descuento, plantel, telefono }) => ({ id_alumno, matricula, folioProspecto, fechaProspecto, puesto, alumno, fecha_inscripcion, alumno_ni, id_grupo, grupo, precio, pagado, adeudo, diferencia, precio_con_descuento, plantel, telefono }));

					this.exportExcel( alumnos, 'Inscripciones')

    		}else{
    			const alumnos = this.filterAlumnos.map(({ id_alumno, matricula, folioProspecto, fechaProspecto, puesto, alumno, fecha_inscripcion, alumno_ni, id_grupo, grupo, precio, pagado, adeudo, diferencia, precio_con_descuento, plantel, clase_row }) => ({ id_alumno, matricula, folioProspecto, fechaProspecto, puesto, alumno, fecha_inscripcion, alumno_ni, id_grupo, grupo, precio, pagado, adeudo, diferencia, precio_con_descuento, plantel, clase_row }));

					this.exportExcel( alumnos, 'Inscripciones')
    		}


    	},

      subirImagen( item ){
        this.alumnoSeleccionado = item
        this.dialogSubirImagen = true
      },

      async procesarImagen2( ){
        this.cargar = true
        this.isPracticaja = false

        var formData = new FormData();
        formData.append("file"             , this.archivos );
        formData.append("newVersion"       , '1' );
        formData.append("noPagos"          , this.noPagos );
        formData.append("id_alumno"        , this.alumnoSeleccionado.id_alumno );

        try{

          const resultado = await this.$http.post('lectura.imagenes.twilio', formData )

          //If we have got parsed results, then loop over the results to do something
          if (resultado) {
            // Guardamos las palabras
            this.texto_completo = resultado.data.numeroTelefono

            this.alumnoSeleccionado.numero_twilio = this.texto_completo

            this.removeFile( )
            // Ahora se necesita actualizar el alumno en la tabla de alumnos del front
            // Necesitamos guardar alumnos en una nueva variable, para limpiara y refrescar la tabla
            let alumnos = this.alumnos
            alumnos = alumnos.map( el => {
              if( el.id_alumno == this.alumnoSeleccionado.id_alumno ){
                el.twilio_texto = this.texto_completo
                return { ...el }
              }else{
                return el
              }
            })

            this.alumnos = alumnos

            this.dialogSubirImagen = false
          }

        }catch( error ){

          if( !this.noPagos ){

            this.removeFile( )

            if( ["DATE_TOO_OLD", "COMPROBANTE_RECHAZADO", "CUENTA_NO_VALIDA", "DUPLICATE_FOUND"].includes( error.response.data.code ) ){
              
              console.log( error.response.data )
              return this.validarErrorDirecto( error.response.data.message )

            }

            this.validarError( error )
          }


        }finally{

          this.cargar = false
        
        }
      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        
        if (!files.length) {
          this.dragging = false;
          return;
        }
        
        this.createFile(files[0]);
      },

      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('please select txt file');
          this.dragging = false;
          return;
        }
        
        if (file.size > 10000000) {
          alert('please check file size no over 5 MB.')
          this.dragging = false;
          return;
        }
        
        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos)
        this.procesarImagen2( )
        this.dragging = false;
      },

      getBase64(file) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevia = {
            url: reader.result, 
            image_name: file.name
          }
        };
      },

      removeFile() {
        this.vistaPrevia  = null
        this.archivos     = null
        this.file         = '';
      },

      async pegar(event) {
        console.log( event )
        if (event.code == "KeyV") {
          const { type, value } = await Clipboard.read();

                    // Validamos que sea de tipo imagen
          if (type == "image/png") {
                    // Convertimos el base64 en una imagen
            const file = this.convertFile(value, "imagen.png");
            this.createFile(file);
          }
        }
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },
    }
  }
</script>


<style>
  #grupos td:nth-child(1) {
    background-color: #E8E8E8 !important;
  }

  #grupos td{
    font-size: 12px !important;
    padding-left: 5px;
    padding-right: 5px;
  }

  .adeudo_alumno{
  	background-color: #FF3030 !important;
  	color: white;
  }

  .alumno_ri{
  	background-color: #8CC339 !important;
  	color: white;
  }

  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }

</style>
